<template>
    <div
        id="cruise-offerte_aanvragen"
        class="cruise-stappen whitebg border2 stap1 width100 marginbottom15"
    >
        <div
            class="stap-header fontsize14 bold lichtblauwbg midblauw padding10 uppercase headerofferteaanvragen"
        >
            Stap {{ this.currentStep }}: Offerte aanvragen
        </div>
        <div class="stap-content" id="formulier-offerte-aanvragen">
            <USPSVertical />

            <div class="floatleft width60">
                <div class="padding10">
                    <div>
                        <!-- Begin offerte aanvraag -->
                        <div class="div_offerte_aanvraag">
                            <div v-if="!offerState.status">
                                <div class="width100">
                                    <p>
                                        Dit is compleet vrijblijvend. Je bent
                                        tot niets verplicht.<br />
                                        Wij nemen binnen maximaal
                                        <b>één werkdag</b> contact met je op.
                                    </p>
                                </div>
                                <span class="label width32 bold lineheight30"
                                    >Volledige naam</span
                                >
                                <input
                                    v-model="naam"
                                    class="height30 width40"
                                    name="offerte_naam"
                                    id="offerte_naam"
                                    type="text"
                                />
                                <div class="clear margintop5 floatleft"></div>
                                <span class="label width32 bold lineheight30"
                                    >E-mailadres</span
                                >
                                <input
                                    v-model="email"
                                    class="height30 width40"
                                    name="offerte_email"
                                    id="offerte_email"
                                    type="text"
                                />
                                <div class="clear margintop5 floatleft"></div>
                                <span class="label width32 bold lineheight30"
                                    >Telefoonnummer</span
                                >
                                <input
                                    v-model="telefoonnummer"
                                    class="height30 width40"
                                    name="offerte_telefoonnummer"
                                    id="offerte_telefoonnummer"
                                    type="text"
                                />
                                <div class="clear margintop5 floatleft"></div>

                                <div class="width100">
                                    <div
                                        class="label width32 bold lineheight30 floatleft"
                                    >
                                        Uw wensen
                                    </div>
                                    <div class="floatleft margintop5">
                                        <input
                                            v-model="vluchten"
                                            id="offerte_checkbox_vluchten"
                                            name="offerte_checkbox_vluchten"
                                            value="Y"
                                            type="checkbox"
                                        /><label
                                            for="offerte_checkbox_vluchten"
                                        >
                                            Vluchten</label
                                        >
                                        <input
                                            v-model="transfers"
                                            class="marginleft10"
                                            id="offerte_checkbox_transfers"
                                            name="offerte_checkbox_transfers"
                                            value="Y"
                                            type="checkbox"
                                        /><label
                                            for="offerte_checkbox_transfers"
                                        >
                                            Transfers</label
                                        >
                                    </div>
                                </div>

                                <div class="clear margintop5 floatleft"></div>

                                <span class="label width32 bold lineheight30"
                                    >Opmerking</span
                                >

                                <textarea
                                    v-model="opmerking"
                                    class="width60 height100 border1"
                                    id="opmerkingen"
                                    name="opmerkingen"
                                    placeholder="Heb je nog bepaalde wensen of zaken waar wij rekening mee kunnen houden?"
                                ></textarea>

                                <div class="clear margintop5 floatleft"></div>

                                <div class="width100 margintop5">
                                    <div
                                        class="niewsbriefLabel label width32 lineheight22 floatleft"
                                    >
                                        <b>Nieuwsbrief</b>
                                        <br /><span>(Optioneel)</span>
                                    </div>
                                    <div class="floatleft">
                                        <input
                                            v-model="nieuwsbrief"
                                            id="offerte_checkbox_nieuwsbrief"
                                            name="offerte_checkbox_nieuwsbrief"
                                            value="Y"
                                            type="checkbox"
                                        /><label
                                            for="offerte_checkbox_nieuwsbrief"
                                        >
                                            Wil jij ook de beste Cruise Deals
                                            ontvangen?</label
                                        >
                                        <br /><i style="margin-left: 24px"
                                            >{{ getSubscribers }} mensen zijn je
                                            voorgegaan.</i
                                        >
                                    </div>
                                </div>

                                <div class="clear margintop5 floatleft"></div>

                                <div
                                    v-for="(warning, index) in warnings"
                                    :key="'warning' + index"
                                    style="color:red;"
                                >
                                    {{ warning }}
                                </div>
                            </div>

                            <div v-if="offerState.status" class="padding20">
                                <div class="font14">
                                    <h2 class="darkblue font20 textcenter">
                                        Je offerte aanvraag is bevestigd!
                                    </h2>
                                    <br />
                                    <p>
                                        Bedankt voor het aanvragen van deze
                                        prachtige cruise vakantie! Je ontvangt
                                        van ons nu een mailtje, met de cruise
                                        die je hebt uitgezocht. Wanneer je een
                                        telefoonnummer hebt achtergelaten, zal
                                        mijn collega bellen om kennis te maken
                                        en je wensen te bespreken.
                                    </p>
                                    <p>
                                        Wil je direct boeken? Dan raad ik je aan
                                        om meteen te bellen. Want net zoals bij
                                        vliegtickets kan een cruiseprijs ook
                                        ieder moment stijgen.
                                    </p>
                                    <p>
                                        Wij zijn 7 dagen in de week bereikbaar
                                        op het volgende telefoonnummer:
                                        <a href="tel:0107200500">010-7200500</a>
                                    </p>
                                    <p>
                                        Wil je liever whatsappen? Dat kan op:
                                        <a
                                            href="https://api.whatsapp.com/send?phone=31615153344"
                                            target="_blank"
                                            >06-15153344</a
                                        >
                                    </p>
                                </div>

                                <div class="clear margintop10"></div>
                            </div>

                            <button
                                v-if="!offerState.status"
                                v-on:click="doOfferRequest()"
                                type="submit"
                                class="button grootbutton groenbg font16 rounded width100 submit_offerte_aanvragen marginbottom10"
                                id="submit_offerte_aanvragen"
                                :disabled="offerState.loading"
                            >
                                Offerte aanvragen&nbsp;&nbsp;&nbsp;
                                <font-awesome-icon
                                    icon="long-arrow-alt-right"
                                />
                            </button>

                            <div class="textcenter">
                                <span style="white-space: nowrap;">
                                    <font-awesome-icon
                                        icon="check"
                                        style="color: #7bbe69"
                                    />
                                    Laagsteprijsgarantie
                                </span>
                                <span style="white-space: nowrap;">
                                    <font-awesome-icon
                                        icon="check"
                                        style="color: #7bbe69"
                                    />
                                    Geen boekingskosten
                                </span>
                            </div>

                            <div class="clear height10"></div>
                            <!-- Eind offerte aanvraag -->

                            <!-- Begin online boeken FIBOS -->
                            <div
                                v-if="showBoeken"
                                class="displaynone_mobile"
                                id="cruise-boeken"
                                style="display: block;"
                            >
                                <div class="width100">
                                    <div
                                        style="border-top:1px solid #efefef ;width: 30%;float: left;margin: 10px auto 10px 50px;"
                                    >
                                        <!-- empty div-->
                                    </div>
                                    <div
                                        style="float:left;width:5%;margin-left:20px;margin-right:15px;"
                                    >
                                        Of
                                    </div>
                                    <div
                                        style="border-top:1px solid #efefef ;width: 30%;margin: 10px auto;float: left;"
                                    />
                                </div>

                                <button
                                    v-on:click="savePaxRedirect"
                                    class="button grootbutton orangebg font16 rounded width100"
                                >
                                    <span>
                                        Bekijk beschikbare hutten
                                    </span>

                                    <font-awesome-icon
                                        icon="long-arrow-alt-right"
                                    />
                                </button>

                                <div
                                    class="nabetaling width100 font11 textcenter paddingtop10"
                                    style="margin-bottom: 8px;"
                                >
                                    De prijzen van cruises kunnen 3 x per dag
                                    veranderen. Door online te boeken verzeker
                                    jezelf van de beste hut en de beste prijs op
                                    dit moment. Have fun! :-)
                                </div>

                                <BetaalMethodesHor />
                            </div>
                        </div>
                        <!-- Eind online boeken FIBOS -->
                    </div>
                </div>
            </div>
        </div>
        <div class="clear marginbottom20"></div>
        <div style="display: none">
            <form name="subscribe" id="submform" method="post">
                <input type="hidden" name="email" :value="email" />
            </form>
        </div>
    </div>
</template>

<script>
import BetaalMethodesHor from './BetaalMethodesHor.vue'
import USPSVertical from './USPSVertical.vue'

export default {
    name: 'offerInput.vue',
    data: function() {
        return {
            naam: '',
            email: '',
            telefoonnummer: '',
            vluchten: false,
            transfers: false,
            nieuwsbrief: false,
            opmerking: '',
            warnings: [],
            loading: false,
        }
    },
    props: { currentStep: Number },
    components: {
        BetaalMethodesHor,
        USPSVertical,
    },
    methods: {
        savePaxRedirect() {
            this.savePaxInfoToLocalStorage()

            //router doesn't get the live changes in the url
            window.location.replace(
                window.location.pathname.replace('overzicht', 'onlineboeken')
            )
        },
        savePaxInfoToLocalStorage() {
            const data = {}
            data.paxType = 'volwassenen'
            if (this.naam && this.naam.length > 1) {
                let words = this.naam.split(' ')
                const voornaam = words[0]
                const achternaam = words[words.length - 1]
                words = words.toString().replace(voornaam, '')
                words = words.toString().replace(achternaam, '')
                const tussenvoegsel = words.replace(/,/g, '')
                if (voornaam && voornaam.length > 1) {
                    data.voornaam = voornaam
                }
                if (tussenvoegsel && tussenvoegsel.length > 1) {
                    data.tussenvoegsel = tussenvoegsel
                }
                if (achternaam && achternaam.length > 1) {
                    data.achternaam = achternaam
                }
            }

            if (this.emailadres && this.emailadres.length > 1) {
                data.emailadres = this.email
            }
            if (this.telefoonnummer && this.telefoonnummer.length > 1) {
                data.telefoonnummer = this.telefoonnummer
            }

            let paxInfoPayload = {}
            if (localStorage.paxInfoPayload) {
                paxInfoPayload = JSON.parse(localStorage.paxInfoPayload)
                if (!paxInfoPayload.obj && !paxInfoPayload.obj.collection) {
                    paxInfoPayload.obj = {}
                }
            } else {
                paxInfoPayload.obj = {}
                paxInfoPayload.obj.collection = []
            }

            paxInfoPayload.obj.collection[0] = data
            if (paxInfoPayload.obj.collection.length > 0) {
                localStorage.paxInfoPayload = JSON.stringify(paxInfoPayload)
            }
        },
        validateEmail: function(email) {
            let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return re.test(String(email).toLowerCase())
        },
        doOfferRequest: function() {
            this.savePaxInfoToLocalStorage()
            this.warnings = []

            if (this.naam === '' || this.naam === null) {
                this.warnings.push('Geen naam ingevuld.')
            }

            if (this.email === '' || this.email === null) {
                this.warnings.push('Geen email adres ingevuld.')
            } else if (!this.validateEmail(this.email)) {
                this.warnings.push('Email adres is onjuist.')
            }

            if (this.offerState.status) {
                this.warnings.push('Offerte aanvraag is al verzonden.')
            }

            if (this.warnings.length === 0) {
                this.$store.dispatch('saveOfferRequest', {
                    naam: this.naam,
                    email: this.email,
                    telefoonnummer: this.telefoonnummer,
                    vluchten: this.vluchten,
                    transfers: this.transfers,
                    opmerking: this.opmerking,
                })
            }
            if (this.nieuwsbrief) {
                $.ajax({
                    url: '/api/cronjob/copernica/copernica_email_proxy.php',
                    method: 'POST',
                    data: $('#submform').serialize(),
                    success: function(responseData) {
                        console.log('saveSubription Request done', responseData)
                    },
                    error: function(error) {
                        console.log('saveSubription Request error', error)
                    },
                })
            }
        },
    },
    computed: {
        showBoeken: function() {
            return this.$store.getters.showBoeken
        },
        getSubscribers: function() {
            return this.$store.state.subscriberCount
        },
        cruise: function() {
            return this.$store.state.cruise
        },
        offerState: function() {
            return this.$store.state.offerStatus
        },
    },
}
</script>

<style scoped>
@media screen and (max-width: 900px) {
    .niewsbriefLabel {
        margin-bottom: 8px;
    }
}
</style>
